module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-insert-48ff133d8bd55020302d5573ae35cdbf.gif";